var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChat = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.418 14.844c.046-.171-.057-.409-.155-.58-.03-.052-.063-.101-.099-.149a7.805 7.805 0 0 1-1.289-4.297c-.014-4.385 3.622-7.943 8.118-7.943 3.921 0 7.194 2.717 7.96 6.323.114.534.172 1.08.172 1.626 0 4.391-3.496 8.005-7.992 8.005-.715 0-1.68-.18-2.206-.327a14.835 14.835 0 0 1-1.187-.395 1.215 1.215 0 0 0-.906.014l-2.65.957a.623.623 0 0 1-.182.047.373.373 0 0 1-.374-.38.618.618 0 0 1 .023-.129l.767-2.772Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
})));
export { SvgChat as ReactComponent };